import {cloneDeep} from 'lodash';

function getServerTreesModelFromCompositeDefinition(expressionTreeModel) {
  const tmpServerTreeObject = {};
  tmpServerTreeObject[expressionTreeModel.id] = cloneDeep(expressionTreeModel);
  return tmpServerTreeObject;
}

export default getServerTreesModelFromCompositeDefinition;
